module.exports = __webpack_public_path__ + "static/media/loosing_1.1c53a609.mp3";